import { render } from "./AppBanner.vue?vue&type=template&id=0b4c4426"
import script from "./AppBanner.vue?vue&type=script&lang=js"
export * from "./AppBanner.vue?vue&type=script&lang=js"

import "./AppBanner.vue?vue&type=style&index=0&id=0b4c4426&lang=scss"

import exportComponent from "/Users/anwarfuadi/Documents/nyp/gigihpack.com/fe/gigihpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__